<template>
  <span
    v-if="pendingApprovalsCount > 0"
    class="unread-count rounded-pill badge text-bg-danger"
    role="status"
    :aria-label="`${pendingApprovalsCount} shift cover requests needing review`"
    >{{ pendingApprovalsCount
    }}<font-awesome-icon
      v-if="icon"
      fixed-width
      icon="people-arrows"
      class="ms-1"
  /></span>
</template>

<script>
import { storeToRefs } from "pinia";
import { useRotaShiftCoverStore } from "@/store/rotashiftcover";

export default {
  props: {
    icon: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const rotaShiftCoverStore = useRotaShiftCoverStore();
    const { pendingApprovalsCount } = storeToRefs(rotaShiftCoverStore);
    return { pendingApprovalsCount };
  },
};
</script>
